// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__Kj8E1","popup":"Search_popup__z_inw","menu":"Search_menu__nTTky","fadeIn":"Search_fadeIn__Zy0tZ","spin":"Search_spin__PBF3t"};